export default __webpack_public_path__ + "static/media/logo.672837a5.png";